const Eyeopen = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <g clipPath="url(#clip0_2056_26496)">
        <path
          d="M12 6C15.79 6 19.17 8.13 20.82 11.5C19.17 14.87 15.79 17 12 17C8.21 17 4.83 14.87 3.18 11.5C4.83 8.13 8.21 6 12 6ZM12 4C7 4 2.73 7.11 1 11.5C2.73 15.89 7 19 12 19C17 19 21.27 15.89 23 11.5C21.27 7.11 17 4 12 4ZM12 9C13.38 9 14.5 10.12 14.5 11.5C14.5 12.88 13.38 14 12 14C10.62 14 9.5 12.88 9.5 11.5C9.5 10.12 10.62 9 12 9ZM12 7C9.52 7 7.5 9.02 7.5 11.5C7.5 13.98 9.52 16 12 16C14.48 16 16.5 13.98 16.5 11.5C16.5 9.02 14.48 7 12 7Z"
          fill="#7E7E7E"
        ></path>
      </g>
      <defs>
        <clipPath id="clip0_2056_26496">
          <rect width="24" height="24" fill="white"></rect>
        </clipPath>
      </defs>
    </svg>
  );
};

const Eyeclose = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="17"
      viewBox="0 0 20 17"
      fill="none"
    >
      <path
        d="M9.99999 13.0001C7.62968 13.0001 5.71093 11.1654 5.53437 8.84039L2.25624 6.30696C1.82531 6.84758 1.42874 7.41914 1.10874 8.04414C1.03726 8.18555 1.00001 8.34179 1.00001 8.50024C1.00001 8.65869 1.03726 8.81492 1.10874 8.95633C2.80343 12.2629 6.15843 14.5001 9.99999 14.5001C10.8409 14.5001 11.6522 14.3751 12.4341 14.1732L10.8125 12.9185C10.5447 12.9703 10.2727 12.9976 9.99999 13.0001ZM19.8069 14.8157L16.3522 12.1457C17.4016 11.2613 18.2647 10.177 18.8912 8.95602C18.9627 8.81461 19 8.65838 19 8.49993C19 8.34147 18.9627 8.18524 18.8912 8.04383C17.1966 4.73727 13.8416 2.50008 9.99999 2.50008C8.39109 2.50203 6.80831 2.90707 5.39624 3.67821L1.42062 0.605395C1.36878 0.565053 1.30949 0.535323 1.24615 0.517902C1.18282 0.500482 1.11667 0.495713 1.05149 0.503868C0.986304 0.512023 0.923369 0.532942 0.866275 0.56543C0.809182 0.597917 0.75905 0.641337 0.718743 0.693207L0.105306 1.48289C0.0239305 1.58758 -0.0125333 1.7203 0.0039342 1.85186C0.0204017 1.98342 0.088452 2.10306 0.193118 2.18446L18.5794 16.3948C18.6312 16.4351 18.6905 16.4648 18.7538 16.4823C18.8172 16.4997 18.8833 16.5045 18.9485 16.4963C19.0137 16.4881 19.0766 16.4672 19.1337 16.4347C19.1908 16.4022 19.2409 16.3588 19.2812 16.307L19.895 15.5173C19.9763 15.4125 20.0127 15.2798 19.9962 15.1482C19.9797 15.0167 19.9116 14.8971 19.8069 14.8157ZM14.0656 10.3782L12.8375 9.42883C12.9409 9.12992 12.9958 8.81636 13 8.50008C13.0061 8.03704 12.9035 7.57902 12.7005 7.16281C12.4975 6.74661 12.1996 6.38382 11.831 6.10359C11.4623 5.82336 11.0331 5.63349 10.5777 5.54925C10.1223 5.46501 9.65358 5.48873 9.20906 5.61852C9.3975 5.87386 9.49943 6.18273 9.49999 6.50008C9.49533 6.60569 9.47919 6.71047 9.45187 6.81258L7.15156 5.03477C7.95061 4.36702 8.95866 4.00085 9.99999 4.00008C10.591 3.99975 11.1763 4.11592 11.7225 4.34195C12.2686 4.56798 12.7648 4.89944 13.1827 5.31737C13.6006 5.7353 13.9321 6.2315 14.1581 6.77762C14.3841 7.32373 14.5003 7.90904 14.5 8.50008C14.5 9.17602 14.3347 9.80602 14.0656 10.3785V10.3782Z"
        fill="#828282"
      />
    </svg>
  );
};

const Dashboardsvg = () => {
  return (
    <svg
      width={20}
      height={20}
      viewBox="0 0 16 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.5 15.6668C15.5 15.8878 15.4122 16.0998 15.2559 16.256C15.0996 16.4123 14.8877 16.5001 14.6667 16.5001H1.33333C1.11232 16.5001 0.900358 16.4123 0.744078 16.256C0.587797 16.0998 0.5 15.8878 0.5 15.6668V6.76178C0.49995 6.6359 0.528416 6.51165 0.583261 6.39835C0.638106 6.28506 0.717905 6.18565 0.816667 6.10761L7.48333 0.848444C7.63046 0.732186 7.81249 0.668945 8 0.668945C8.18751 0.668945 8.36954 0.732186 8.51667 0.848444L15.1833 6.10678C15.2822 6.18491 15.3621 6.28444 15.4169 6.39789C15.4718 6.51135 15.5002 6.63576 15.5 6.76178V15.6668ZM3.83333 9.00011C3.83333 10.1052 4.27232 11.165 5.05372 11.9464C5.83512 12.7278 6.89493 13.1668 8 13.1668C9.10507 13.1668 10.1649 12.7278 10.9463 11.9464C11.7277 11.165 12.1667 10.1052 12.1667 9.00011H10.5C10.5 9.66315 10.2366 10.299 9.76777 10.7679C9.29893 11.2367 8.66304 11.5001 8 11.5001C7.33696 11.5001 6.70107 11.2367 6.23223 10.7679C5.76339 10.299 5.5 9.66315 5.5 9.00011H3.83333Z"
        fill="black"
      />
    </svg>
  );
};
const Contractsvg = () => {
  return (
    <svg
      width={20}
      height={20}
      viewBox="0 0 19 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16.4062 0H2.34375C1.0498 0 0 1.0498 0 2.34375V22.6562C0 23.9502 1.0498 25 2.34375 25H16.4062C17.7002 25 18.75 23.9502 18.75 22.6562V2.34375C18.75 1.0498 17.7002 0 16.4062 0ZM7.03125 1.5625H11.7188C12.1484 1.5625 12.5 1.91406 12.5 2.34375C12.5 2.77344 12.1484 3.125 11.7188 3.125H7.03125C6.60156 3.125 6.25 2.77344 6.25 2.34375C6.25 1.91406 6.60156 1.5625 7.03125 1.5625ZM9.375 7.8125C11.0986 7.8125 12.5 9.21387 12.5 10.9375C12.5 12.6611 11.0986 14.0625 9.375 14.0625C7.65137 14.0625 6.25 12.6611 6.25 10.9375C6.25 9.21387 7.65137 7.8125 9.375 7.8125ZM14.8438 19.375C14.8438 19.8926 14.3555 20.3125 13.75 20.3125H5C4.39453 20.3125 3.90625 19.8926 3.90625 19.375V18.4375C3.90625 16.8848 5.37598 15.625 7.1875 15.625H7.43164C8.03223 15.874 8.68652 16.0156 9.375 16.0156C10.0635 16.0156 10.7227 15.874 11.3184 15.625H11.5625C13.374 15.625 14.8438 16.8848 14.8438 18.4375V19.375Z"
        fill="black"
      />
    </svg>
  );
};

const Manageapplication = () => {
  return (
    <svg
      width={20}
      height={20}
      viewBox="0 0 25 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M25 10.3125V9.6875C25 9.34219 24.7203 9.0625 24.375 9.0625H13.4375V7.5H16.25C16.9402 7.5 17.5 6.94023 17.5 6.25V1.25C17.5 0.559766 16.9402 0 16.25 0H8.75C8.05977 0 7.5 0.559766 7.5 1.25V6.25C7.5 6.94023 8.05977 7.5 8.75 7.5H11.5625V9.0625H0.625C0.279687 9.0625 0 9.34219 0 9.6875V10.3125C0 10.6578 0.279687 10.9375 0.625 10.9375H4.6875V12.5H2.5C1.80977 12.5 1.25 13.0598 1.25 13.75V18.75C1.25 19.4402 1.80977 20 2.5 20H8.75C9.44023 20 10 19.4402 10 18.75V13.75C10 13.0598 9.44023 12.5 8.75 12.5H6.5625V10.9375H18.4375V12.5H16.25C15.5598 12.5 15 13.0598 15 13.75V18.75C15 19.4402 15.5598 20 16.25 20H22.5C23.1902 20 23.75 19.4402 23.75 18.75V13.75C23.75 13.0598 23.1902 12.5 22.5 12.5H20.3125V10.9375H24.375C24.7203 10.9375 25 10.6578 25 10.3125ZM10 5V2.5H15V5H10ZM7.5 17.5H3.75V15H7.5V17.5ZM21.25 17.5H17.5V15H21.25V17.5Z"
        fill="black"
      />
    </svg>
  );
};

const AdminSettingsSvg = () => (
    <svg  width={20}
      height={20} viewBox="0 0 24 24" fill="none">
    <circle cx="12" cy="12" r="3" stroke="currentColor" strokeWidth="2" />
    <path
      d="M19.4 15a1.7 1.7 0 0 0 .3 1.9l.1.1a2 2 0 0 1-2.8 2.8l-.1-.1a1.7 1.7 0 0 0-1.9-.3 1.7 1.7 0 0 0-1 1.5V21a2 2 0 0 1-4 0v-.1a1.7 1.7 0 0 0-1-1.5 1.7 1.7 0 0 0-1.9.3l-.1.1a2 2 0 0 1-2.8-2.8l.1-.1a1.7 1.7 0 0 0 .3-1.9 1.7 1.7 0 0 0-1.5-1H3a2 2 0 0 1 0-4h.1a1.7 1.7 0 0 0 1.5-1 1.7 1.7 0 0 0-.3-1.9l-.1-.1A2 2 0 0 1 7 3.2l.1.1a1.7 1.7 0 0 0 1.9.3H9a1.7 1.7 0 0 0 1-1.5V2a2 2 0 0 1 4 0v.1a1.7 1.7 0 0 0 1 1.5h.1a1.7 1.7 0 0 0 1.9-.3l.1-.1a2 2 0 1 1 2.8 2.8l-.1.1a1.7 1.7 0 0 0-.3 1.9V9c0 .7.4 1.3 1.1 1.5H21a2 2 0 0 1 0 4h-.1a1.7 1.7 0 0 0-1.5 1z"
      stroke="currentColor"
      strokeWidth="2"
    />
  </svg>
);

const ProjectsSvg = () => (
  <svg width={20} height={20} viewBox="0 0 24 24" fill="none">
    <rect x="2" y="3" width="20" height="18" rx="3" stroke="currentColor" strokeWidth="2"/>
    <path d="M8 3v18" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
    <path d="M2 9h20" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
    <path d="M12 13h5" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
    <path d="M12 17h3" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
  </svg>
);
const BTTeamStatusSvg = () => (
  <svg width={20} height={20} viewBox="0 0 24 24" fill="none">
    {/* Team people */}
    <circle cx="9" cy="7" r="3" stroke="currentColor" strokeWidth="2"/>
    <circle cx="17" cy="7" r="2.5" stroke="currentColor" strokeWidth="2"/>
    {/* Status bar / body */}
    <path d="M3 19c0-3.314 2.686-6 6-6s6 2.686 6 6" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
    <path d="M17 14c1.657 0 3 1.343 3 3v1" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
    {/* Status dot indicator */}
    <circle cx="20" cy="5" r="2.5" fill="currentColor"/>
  </svg>
);

const CurrentTeamStatusSvg = () => (
  <svg width={20} height={20} viewBox="0 0 24 24" fill="none">
    {/* People/Team */}
    <circle cx="12" cy="7" r="3" stroke="currentColor" strokeWidth="2"/>
    <path d="M5 19c0-3.866 3.134-7 7-7s7 3.134 7 7" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
    {/* Status pulse / current indicator */}
    <circle cx="19" cy="5" r="1.5" fill="currentColor"/>
    <circle cx="19" cy="5" r="3" stroke="currentColor" strokeWidth="1.5" opacity="0.4"/>
  </svg>
);

const ReportsSvg = () => (
  <svg
    width={20}
    height={20}
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M3 3v18h18"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7 15l4-4 3 3 5-6"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);



const HourlySvg = () => (
<svg width={20} height={20} viewBox="0 0 24 24" fill="none">
    <circle
      cx="12"
      cy="14"
      r="7"
      stroke="currentColor"
      strokeWidth="2"
    />
    <path
      d="M9 2h6"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
    />
    <path
      d="M12 14v-3"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
    />
  </svg>
);



const FinecialSvg = () => (
 <svg width={20} height={20} viewBox="0 0 24 24" fill="none">
    <rect
      x="3"
      y="6"
      width="18"
      height="12"
      rx="2"
      stroke="currentColor"
      strokeWidth="2"
    />
    <path
      d="M3 10h18M7 15h4"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
    />
  </svg>
);

const EmployeePlSvg = () => (
   <svg width={20} height={20} viewBox="0 0 24 24" fill="none">
    {/* User Icon */}
    <circle cx="8" cy="8" r="3" stroke="currentColor" strokeWidth="2" />
    <path
      d="M2 20C2 16.5 5 14 8 14C11 14 14 16.5 14 20"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
    />

    {/* Chart / PL Graph */}
    <path
      d="M14 16L17 13L19 15L22 11"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />

    {/* Axis */}
    <path
      d="M14 20H22"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
    />
  </svg>
);


const ReportReciptSvg = () => {
  return (
    <svg
      width={20}
      height={20}
      viewBox="0 0 25 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M22.9167 0H2.08333C0.93316 0 0 0.93316 0 2.08333V2.77778H25V2.08333C25 0.93316 24.0668 0 22.9167 0ZM0 17.3611C0 18.5113 0.93316 19.4444 2.08333 19.4444H22.9167C24.0668 19.4444 25 18.5113 25 17.3611V4.16667H0V17.3611ZM15.2778 7.29167C15.2778 7.10069 15.434 6.94444 15.625 6.94444H21.875C22.066 6.94444 22.2222 7.10069 22.2222 7.29167V7.98611C22.2222 8.17708 22.066 8.33333 21.875 8.33333H15.625C15.434 8.33333 15.2778 8.17708 15.2778 7.98611V7.29167ZM15.2778 10.0694C15.2778 9.87847 15.434 9.72222 15.625 9.72222H21.875C22.066 9.72222 22.2222 9.87847 22.2222 10.0694V10.7639C22.2222 10.9549 22.066 11.1111 21.875 11.1111H15.625C15.434 11.1111 15.2778 10.9549 15.2778 10.7639V10.0694ZM15.2778 12.8472C15.2778 12.6562 15.434 12.5 15.625 12.5H21.875C22.066 12.5 22.2222 12.6562 22.2222 12.8472V13.5417C22.2222 13.7326 22.066 13.8889 21.875 13.8889H15.625C15.434 13.8889 15.2778 13.7326 15.2778 13.5417V12.8472ZM7.63889 6.94444C9.17101 6.94444 10.4167 8.1901 10.4167 9.72222C10.4167 11.2543 9.17101 12.5 7.63889 12.5C6.10677 12.5 4.86111 11.2543 4.86111 9.72222C4.86111 8.1901 6.10677 6.94444 7.63889 6.94444ZM2.91233 15.8073C3.27691 14.6918 4.32292 13.8889 5.55556 13.8889H5.91146C6.44531 14.1102 7.02691 14.2361 7.63889 14.2361C8.25087 14.2361 8.83681 14.1102 9.36632 13.8889H9.72222C10.9549 13.8889 12.0009 14.6918 12.3655 15.8073C12.5043 16.237 12.1398 16.6667 11.6884 16.6667H3.58941C3.13802 16.6667 2.77344 16.2326 2.91233 15.8073Z"
        fill="black"
      />
    </svg>
  );
};

const Manageroletab = () => {
  return (
    <svg
      width={20}
      height={20}
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M21.875 6.29883V5.25879L20.4834 4.8291L20.376 4.32129L21.3574 3.31055L20.8496 2.36328L19.4336 2.72949L19.082 2.36328L19.4482 0.986328L18.5156 0.419922L17.4756 1.44531L16.9531 1.28906L16.6113 0H15.5078L15.2051 1.28906L14.6143 1.44531L13.6523 0.419922L12.7051 0.957031L13.1006 2.30957L12.7051 2.71973L11.3135 2.35352L10.7764 3.28613L11.7871 4.31152L11.6455 4.81934L10.2539 5.2002L10.2393 6.25977L11.6455 6.62598L11.7627 7.2168L10.7813 8.18848L11.2891 9.0918L12.7344 8.72559L13.0859 9.14551L12.6904 10.459L13.6621 11.0254L14.6094 10.0293L15.1758 10.1709L15.5029 11.5625L16.6064 11.5771L16.9336 10.1709L17.5 10L18.5107 11.0547L19.5068 10.4639L19.0771 9.09668L19.458 8.70117L20.8643 9.13086L21.3672 8.14941L20.3467 7.23145L20.4541 6.64062L21.875 6.29883ZM16.0547 8.50586C14.5264 8.50586 13.2812 7.26562 13.2812 5.73242C13.2812 4.19922 14.5215 2.95898 16.0547 2.95898C17.5879 2.95898 18.8281 4.19922 18.8281 5.73242C18.8281 7.27051 17.5879 8.50586 16.0547 8.50586ZM19.585 9.30664L21.875 10.0146V11.9629L19.1846 12.6172L18.9844 13.7256L20.8838 15.4492L19.9463 17.2998L17.3096 16.4844L16.5967 17.2266L17.4121 19.79L15.542 20.8984L13.6426 18.9209L12.583 19.2432L11.9678 21.8799L9.89746 21.8555L9.28223 19.2383L8.22266 18.9648L6.44531 20.8398L4.61914 19.7803L5.36133 17.3145L4.69238 16.5283L1.98242 17.2168L1.02051 15.5176L2.87109 13.6914L2.63672 12.5781L0 11.8896L0.0244141 9.89258L2.63672 9.1748L2.91504 8.21289L1.01562 6.28906L2.02637 4.54102L4.64355 5.22949L5.38574 4.46289L4.64355 1.92383L6.4209 0.913086L8.21777 2.83691L9.32617 2.53906L9.89258 0H11.9629L12.5293 2.24121L11.4258 1.95312L11.1182 1.87012L10.957 2.14844L10.4199 3.08105L10.2588 3.35449L10.4834 3.5791L11.3232 4.42871L11.3086 4.47754L10.1465 4.79492L9.84375 4.87793L9.83887 5.19043L9.8291 5.82031C7.50977 6.32812 5.76172 8.39844 5.76172 10.874C5.76172 13.7207 8.07129 16.0352 10.9229 16.0352C13.3887 16.0352 15.4492 14.3066 15.9619 11.9922L16.6064 12.002L16.9434 12.0068L17.0215 11.6797L17.2949 10.5078L17.3877 10.4785L18.2227 11.3477L18.4521 11.5869L18.7354 11.4209L19.7314 10.8301L20.0146 10.6592L19.917 10.3418L19.585 9.30664Z"
        fill="black"
      />
    </svg>
  );
};

const Vendororder = () => {
  return (
    <svg
      width={20}
      height={20}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M19 6.5H16V5.5C16 4.70435 15.6839 3.94129 15.1213 3.37868C14.5587 2.81607 13.7956 2.5 13 2.5H11C10.2044 2.5 9.44129 2.81607 8.87868 3.37868C8.31607 3.94129 8 4.70435 8 5.5V6.5H5C4.20435 6.5 3.44129 6.81607 2.87868 7.37868C2.31607 7.94129 2 8.70435 2 9.5V18.5C2 19.2956 2.31607 20.0587 2.87868 20.6213C3.44129 21.1839 4.20435 21.5 5 21.5H19C19.7956 21.5 20.5587 21.1839 21.1213 20.6213C21.6839 20.0587 22 19.2956 22 18.5V9.5C22 8.70435 21.6839 7.94129 21.1213 7.37868C20.5587 6.81607 19.7956 6.5 19 6.5ZM10 5.5C10 5.23478 10.1054 4.98043 10.2929 4.79289C10.4804 4.60536 10.7348 4.5 11 4.5H13C13.2652 4.5 13.5196 4.60536 13.7071 4.79289C13.8946 4.98043 14 5.23478 14 5.5V6.5H10V5.5ZM20 18.5C20 18.7652 19.8946 19.0196 19.7071 19.2071C19.5196 19.3946 19.2652 19.5 19 19.5H5C4.73478 19.5 4.48043 19.3946 4.29289 19.2071C4.10536 19.0196 4 18.7652 4 18.5V13C4.97544 13.3869 5.97818 13.7011 7 13.94V14.53C7 14.7952 7.10536 15.0496 7.29289 15.2371C7.48043 15.4246 7.73478 15.53 8 15.53C8.26522 15.53 8.51957 15.4246 8.70711 15.2371C8.89464 15.0496 9 14.7952 9 14.53V14.32C9.99435 14.4554 10.9965 14.5255 12 14.53C13.0035 14.5255 14.0057 14.4554 15 14.32V14.53C15 14.7952 15.1054 15.0496 15.2929 15.2371C15.4804 15.4246 15.7348 15.53 16 15.53C16.2652 15.53 16.5196 15.4246 16.7071 15.2371C16.8946 15.0496 17 14.7952 17 14.53V13.94C18.0218 13.7011 19.0246 13.3869 20 13V18.5ZM20 10.81C19.0274 11.2205 18.0244 11.5548 17 11.81V11.5C17 11.2348 16.8946 10.9804 16.7071 10.7929C16.5196 10.6054 16.2652 10.5 16 10.5C15.7348 10.5 15.4804 10.6054 15.2929 10.7929C15.1054 10.9804 15 11.2348 15 11.5V12.24C13.0113 12.54 10.9887 12.54 9 12.24V11.5C9 11.2348 8.89464 10.9804 8.70711 10.7929C8.51957 10.6054 8.26522 10.5 8 10.5C7.73478 10.5 7.48043 10.6054 7.29289 10.7929C7.10536 10.9804 7 11.2348 7 11.5V11.83C5.97562 11.5748 4.9726 11.2405 4 10.83V9.5C4 9.23478 4.10536 8.98043 4.29289 8.79289C4.48043 8.60536 4.73478 8.5 5 8.5H19C19.2652 8.5 19.5196 8.60536 19.7071 8.79289C19.8946 8.98043 20 9.23478 20 9.5V10.81Z"
        fill="black"
      />
    </svg>
  );
};
const LeaveManagement = () => {
  return (
     <svg
      width={20}
      height={20}
      viewBox="0 0 24 24"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M19 4h-1V2h-2v2H8V2H6v2H5c-1.1 0-2 .9-2 2v14c0 
      1.1.9 2 2 2h14c1.1 0 2-.9 
      2-2V6c0-1.1-.9-2-2-2zm0 
      16H5V9h14v11z"/>
      <path d="M10 17l-2-2 1.4-1.4L10 
      14.2l4.6-4.6L16 11l-6 6z"/>
    </svg>
  );
};
const PrintSvg = () => {
  return (
     <svg width={20} height={20} viewBox="0 0 24 24" fill="none">
    {/* Clipboard base */}
    <rect x="4" y="4" width="16" height="18" rx="2" stroke="currentColor" strokeWidth="2"/>
    {/* Clipboard top */}
    <path d="M9 4V3a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v1" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
    {/* Check mark - completed task */}
    <path d="M8 12l2 2 4-4" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    {/* Task lines */}
    <path d="M8 17h8" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
    <path d="M8 20h5" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
  </svg>
  );
};

const StatsSvg = () => {
  return (
    <svg
  width={20}
      height={20}
  viewBox="0 0 24 24"
  xmlns="http://www.w3.org/2000/svg"
  fill="#000000"
>
  <g id="SVGRepo_bgCarrier" strokeWidth={0} />
  <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round" />
  <g id="SVGRepo_iconCarrier">
    {" "}
    <rect x={0} fill="none" width={24} height={24} />{" "}
    <g>
      {" "}
      <path d="M19 3H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2zm0 16H5V5h14v14zM9 17H7V7h2v10zm4 0h-2v-7h2v7zm4 0h-2v-5h2v5z" />{" "}
    </g>{" "}
  </g>
</svg>

  );
};
const ReportOrderReport = () => {
  return (
    <svg
      width={22}
      height={22}
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_388_1610)">
        <path
          d="M5.04175 7.33335H5.50008V7.79169C5.50008 8.0348 5.59666 8.26796 5.76857 8.43987C5.94047 8.61178 6.17363 8.70835 6.41675 8.70835C6.65986 8.70835 6.89302 8.61178 7.06493 8.43987C7.23684 8.26796 7.33341 8.0348 7.33341 7.79169V7.33335H7.79175C8.03486 7.33335 8.26802 7.23678 8.43993 7.06487C8.61184 6.89296 8.70841 6.6598 8.70841 6.41669C8.70841 6.17357 8.61184 5.94041 8.43993 5.76851C8.26802 5.5966 8.03486 5.50002 7.79175 5.50002H7.33341V5.04169C7.33341 4.79857 7.23684 4.56541 7.06493 4.39351C6.89302 4.2216 6.65986 4.12502 6.41675 4.12502C6.17363 4.12502 5.94047 4.2216 5.76857 4.39351C5.59666 4.56541 5.50008 4.79857 5.50008 5.04169V5.50002H5.04175C4.79863 5.50002 4.56548 5.5966 4.39357 5.76851C4.22166 5.94041 4.12508 6.17357 4.12508 6.41669C4.12508 6.6598 4.22166 6.89296 4.39357 7.06487C4.56548 7.23678 4.79863 7.33335 5.04175 7.33335ZM4.47341 17.5267C4.64516 17.6974 4.87749 17.7932 5.11966 17.7932C5.36184 17.7932 5.59417 17.6974 5.76591 17.5267L6.41675 16.8759L7.06758 17.5267C7.23933 17.6974 7.47166 17.7932 7.71383 17.7932C7.956 17.7932 8.18833 17.6974 8.36008 17.5267C8.53081 17.3549 8.62664 17.1226 8.62664 16.8804C8.62664 16.6383 8.53081 16.4059 8.36008 16.2342L7.70925 15.5834L8.36008 14.9325C8.51026 14.7572 8.58873 14.5316 8.57982 14.3009C8.57091 14.0702 8.47527 13.8513 8.31201 13.6881C8.14876 13.5248 7.92992 13.4292 7.69921 13.4203C7.46851 13.4114 7.24294 13.4898 7.06758 13.64L6.41675 14.2909L5.76591 13.64C5.59055 13.4898 5.36499 13.4114 5.13428 13.4203C4.90358 13.4292 4.68474 13.5248 4.52148 13.6881C4.35823 13.8513 4.26259 14.0702 4.25368 14.3009C4.24477 14.5316 4.32324 14.7572 4.47341 14.9325L5.12425 15.5834L4.47341 16.2342C4.30268 16.4059 4.20685 16.6383 4.20685 16.8804C4.20685 17.1226 4.30268 17.3549 4.47341 17.5267ZM18.3334 0.916687H3.66675C2.9374 0.916687 2.23793 1.20642 1.7222 1.72214C1.20648 2.23787 0.916748 2.93734 0.916748 3.66669V18.3334C0.916748 19.0627 1.20648 19.7622 1.7222 20.2779C2.23793 20.7936 2.9374 21.0834 3.66675 21.0834H18.3334C19.0628 21.0834 19.7622 20.7936 20.278 20.2779C20.7937 19.7622 21.0834 19.0627 21.0834 18.3334V3.66669C21.0834 2.93734 20.7937 2.23787 20.278 1.72214C19.7622 1.20642 19.0628 0.916687 18.3334 0.916687ZM10.0834 19.25H3.66675C3.42363 19.25 3.19047 19.1534 3.01857 18.9815C2.84666 18.8096 2.75008 18.5765 2.75008 18.3334V11.9167H10.0834V19.25ZM10.0834 10.0834H2.75008V3.66669C2.75008 3.42357 2.84666 3.19041 3.01857 3.01851C3.19047 2.8466 3.42363 2.75002 3.66675 2.75002H10.0834V10.0834ZM19.2501 18.3334C19.2501 18.5765 19.1535 18.8096 18.9816 18.9815C18.8097 19.1534 18.5765 19.25 18.3334 19.25H11.9167V11.9167H19.2501V18.3334ZM19.2501 10.0834H11.9167V2.75002H18.3334C18.5765 2.75002 18.8097 2.8466 18.9816 3.01851C19.1535 3.19041 19.2501 3.42357 19.2501 3.66669V10.0834ZM14.2084 15.125H16.9584C17.2015 15.125 17.4347 15.0284 17.6066 14.8565C17.7785 14.6846 17.8751 14.4515 17.8751 14.2084C17.8751 13.9652 17.7785 13.7321 17.6066 13.5602C17.4347 13.3883 17.2015 13.2917 16.9584 13.2917H14.2084C13.9653 13.2917 13.7321 13.3883 13.5602 13.5602C13.3883 13.7321 13.2917 13.9652 13.2917 14.2084C13.2917 14.4515 13.3883 14.6846 13.5602 14.8565C13.7321 15.0284 13.9653 15.125 14.2084 15.125ZM16.9584 5.50002H14.2084C13.9653 5.50002 13.7321 5.5966 13.5602 5.76851C13.3883 5.94041 13.2917 6.17357 13.2917 6.41669C13.2917 6.6598 13.3883 6.89296 13.5602 7.06487C13.7321 7.23678 13.9653 7.33335 14.2084 7.33335H16.9584C17.2015 7.33335 17.4347 7.23678 17.6066 7.06487C17.7785 6.89296 17.8751 6.6598 17.8751 6.41669C17.8751 6.17357 17.7785 5.94041 17.6066 5.76851C17.4347 5.5966 17.2015 5.50002 16.9584 5.50002ZM14.2084 17.875H16.9584C17.2015 17.875 17.4347 17.7784 17.6066 17.6065C17.7785 17.4346 17.8751 17.2015 17.8751 16.9584C17.8751 16.7152 17.7785 16.4821 17.6066 16.3102C17.4347 16.1383 17.2015 16.0417 16.9584 16.0417H14.2084C13.9653 16.0417 13.7321 16.1383 13.5602 16.3102C13.3883 16.4821 13.2917 16.7152 13.2917 16.9584C13.2917 17.2015 13.3883 17.4346 13.5602 17.6065C13.7321 17.7784 13.9653 17.875 14.2084 17.875Z"
          fill="black"
        />
      </g>
      <defs>
        <clipPath id="clip0_388_1610">
          <rect width={22} height={22} fill="black" />
        </clipPath>
      </defs>
    </svg>
  );
};
const ReportTaxReport = () => {
  return (
    <svg
      width={24}
      height={24}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15 11H13V7C13 6.73478 12.8946 6.48043 12.7071 6.29289C12.5196 6.10536 12.2652 6 12 6C11.7348 6 11.4804 6.10536 11.2929 6.29289C11.1054 6.48043 11 6.73478 11 7V12C11 12.2652 11.1054 12.5196 11.2929 12.7071C11.4804 12.8946 11.7348 13 12 13H15C15.2652 13 15.5196 12.8946 15.7071 12.7071C15.8946 12.5196 16 12.2652 16 12C16 11.7348 15.8946 11.4804 15.7071 11.2929C15.5196 11.1054 15.2652 11 15 11ZM12 2C10.0222 2 8.08879 2.58649 6.4443 3.6853C4.79981 4.78412 3.51808 6.3459 2.76121 8.17317C2.00433 10.0004 1.8063 12.0111 2.19215 13.9509C2.578 15.8907 3.53041 17.6725 4.92893 19.0711C6.32746 20.4696 8.10929 21.422 10.0491 21.8079C11.9889 22.1937 13.9996 21.9957 15.8268 21.2388C17.6541 20.4819 19.2159 19.2002 20.3147 17.5557C21.4135 15.9112 22 13.9778 22 12C21.9971 9.34874 20.9425 6.80691 19.0678 4.93219C17.1931 3.05746 14.6513 2.00295 12 2ZM12 20C10.4178 20 8.87103 19.5308 7.55544 18.6518C6.23985 17.7727 5.21447 16.5233 4.60896 15.0615C4.00346 13.5997 3.84504 11.9911 4.15372 10.4393C4.4624 8.88743 5.22433 7.46197 6.34315 6.34315C7.46197 5.22433 8.88743 4.4624 10.4393 4.15372C11.9911 3.84504 13.5997 4.00346 15.0615 4.60896C16.5233 5.21447 17.7727 6.23984 18.6518 7.55544C19.5308 8.87103 20 10.4177 20 12C19.9976 14.121 19.1539 16.1544 17.6542 17.6542C16.1544 19.1539 14.121 19.9976 12 20Z"
        fill="black"
      />
    </svg>
  );
};
const NotificationSvg = () => {
  return (
    <svg
      width={24}
      height={24}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.7258 7.34056C12.1397 7.32632 12.4638 6.97919 12.4495 6.56522C12.4353 6.15125 12.0882 5.8272 11.6742 5.84144L11.7258 7.34056ZM7.15843 11.562L6.40879 11.585C6.40906 11.5938 6.40948 11.6026 6.41006 11.6114L7.15843 11.562ZM5.87826 14.979L6.36787 15.5471C6.38128 15.5356 6.39428 15.5236 6.40684 15.5111L5.87826 14.979ZM5.43951 15.342L5.88007 15.949C5.89245 15.94 5.90455 15.9306 5.91636 15.9209L5.43951 15.342ZM9.74998 17.75C10.1642 17.75 10.5 17.4142 10.5 17C10.5 16.5858 10.1642 16.25 9.74998 16.25V17.75ZM11.7258 5.84144C11.3118 5.8272 10.9647 6.15125 10.9504 6.56522C10.9362 6.97919 11.2602 7.32632 11.6742 7.34056L11.7258 5.84144ZM16.2415 11.562L16.9899 11.6113C16.9905 11.6025 16.9909 11.5938 16.9912 11.585L16.2415 11.562ZM17.5217 14.978L16.9931 15.5101C17.0057 15.5225 17.0187 15.5346 17.0321 15.5461L17.5217 14.978ZM17.9605 15.341L17.4836 15.9199C17.4952 15.9294 17.507 15.9386 17.5191 15.9474L17.9605 15.341ZM13.65 16.25C13.2358 16.25 12.9 16.5858 12.9 17C12.9 17.4142 13.2358 17.75 13.65 17.75V16.25ZM10.95 6.591C10.95 7.00521 11.2858 7.341 11.7 7.341C12.1142 7.341 12.45 7.00521 12.45 6.591H10.95ZM12.45 5C12.45 4.58579 12.1142 4.25 11.7 4.25C11.2858 4.25 10.95 4.58579 10.95 5H12.45ZM9.74998 16.25C9.33577 16.25 8.99998 16.5858 8.99998 17C8.99998 17.4142 9.33577 17.75 9.74998 17.75V16.25ZM13.65 17.75C14.0642 17.75 14.4 17.4142 14.4 17C14.4 16.5858 14.0642 16.25 13.65 16.25V17.75ZM10.5 17C10.5 16.5858 10.1642 16.25 9.74998 16.25C9.33577 16.25 8.99998 16.5858 8.99998 17H10.5ZM14.4 17C14.4 16.5858 14.0642 16.25 13.65 16.25C13.2358 16.25 12.9 16.5858 12.9 17H14.4ZM11.6742 5.84144C8.65236 5.94538 6.31509 8.53201 6.40879 11.585L7.90808 11.539C7.83863 9.27613 9.56498 7.41488 11.7258 7.34056L11.6742 5.84144ZM6.41006 11.6114C6.48029 12.6748 6.08967 13.7118 5.34968 14.4469L6.40684 15.5111C7.45921 14.4656 8.00521 13.0026 7.9068 11.5126L6.41006 11.6114ZM5.38865 14.4109C5.23196 14.5459 5.10026 14.6498 4.96265 14.7631L5.91636 15.9209C6.0264 15.8302 6.195 15.6961 6.36787 15.5471L5.38865 14.4109ZM4.99895 14.735C4.77969 14.8942 4.58045 15.1216 4.43193 15.3617C4.28525 15.5987 4.14491 15.9178 4.12693 16.2708C4.10726 16.6569 4.24026 17.0863 4.63537 17.3884C4.98885 17.6588 5.45464 17.75 5.94748 17.75V16.25C5.78415 16.25 5.67611 16.234 5.60983 16.2171C5.54411 16.2004 5.53242 16.1861 5.54658 16.1969C5.56492 16.211 5.59211 16.2408 5.61004 16.2837C5.62632 16.3228 5.62492 16.3484 5.62499 16.3472C5.62513 16.3443 5.62712 16.3233 5.6414 16.2839C5.65535 16.2454 5.67733 16.1997 5.70749 16.151C5.73748 16.1025 5.77159 16.0574 5.80538 16.0198C5.84013 15.981 5.86714 15.9583 5.88007 15.949L4.99895 14.735ZM5.94748 17.75H9.74998V16.25H5.94748V17.75ZM11.6742 7.34056C13.835 7.41488 15.5613 9.27613 15.4919 11.539L16.9912 11.585C17.0849 8.53201 14.7476 5.94538 11.7258 5.84144L11.6742 7.34056ZM15.4932 11.5127C15.3951 13.0024 15.9411 14.4649 16.9931 15.5101L18.0503 14.4459C17.3105 13.711 16.9199 12.6744 16.9899 11.6113L15.4932 11.5127ZM17.0321 15.5461C17.205 15.6951 17.3736 15.8292 17.4836 15.9199L18.4373 14.7621C18.2997 14.6488 18.168 14.5449 18.0113 14.4099L17.0321 15.5461ZM17.5191 15.9474C17.5325 15.9571 17.5599 15.9802 17.5949 16.0193C17.629 16.0573 17.6634 16.1026 17.6937 16.1514C17.7241 16.2004 17.7463 16.2463 17.7604 16.285C17.7748 16.3246 17.7769 16.3457 17.777 16.3485C17.7771 16.3497 17.7756 16.3238 17.792 16.2844C17.81 16.241 17.8375 16.211 17.856 16.1968C17.8702 16.1859 17.8585 16.2002 17.7925 16.217C17.7259 16.234 17.6174 16.25 17.4535 16.25V17.75C17.9468 17.75 18.4132 17.6589 18.7669 17.3885C19.1628 17.0859 19.2954 16.6557 19.2749 16.2693C19.2562 15.9161 19.1151 15.5972 18.9682 15.3604C18.8194 15.1206 18.6202 14.8936 18.4018 14.7346L17.5191 15.9474ZM17.4535 16.25H13.65V17.75H17.4535V16.25ZM12.45 6.591V5H10.95V6.591H12.45ZM9.74998 17.75H13.65V16.25H9.74998V17.75ZM8.99998 17C8.99998 18.5008 10.191 19.75 11.7 19.75V18.25C11.055 18.25 10.5 17.7084 10.5 17H8.99998ZM11.7 19.75C13.2089 19.75 14.4 18.5008 14.4 17H12.9C12.9 17.7084 12.3449 18.25 11.7 18.25V19.75Z"
        fill="#000000"
      />
    </svg>
  );
};

const SuportSvg = () => {
  return (
    <svg
      version="1.1"
      id="Layer_1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      width={24}
      height={24}
      viewBox="0 0 40 32"
      enableBackground="new 0 0 40 32"
      xmlSpace="preserve"
    >
      <g>
        <path
          fill="#000000"
          d="M34.91,14.667c-0.067-3.497-1.359-6.884-3.691-9.549c-2.84-3.248-6.938-5.111-11.242-5.111
		c-4.311,0-8.408,1.859-11.242,5.1c-2.355,2.693-3.63,6.121-3.673,9.651c-2.922,0.5-5.084,2.941-5.124,5.919
		c-0.012,0.042-0.018,0.086-0.018,0.13C-0.08,24.222,2.672,27,6.055,27h4.539c2.056,3.03,5.527,5,9.383,5
		c5.647,0,10.476-4.221,11.229-9.819l0.758-5.633c0.466-3.458-0.585-6.948-2.882-9.574s-5.615-4.133-9.104-4.133
		s-6.808,1.506-9.104,4.133S7.524,13.09,7.99,16.548l0.758,5.633c0.184,1.37,0.616,2.656,1.24,3.819H7.919
		c-0.486-1.093-0.824-2.292-0.996-3.573l-0.758-5.631c-0.064-0.474-0.099-0.948-0.114-1.421c0.037-0.078,0.062-0.162,0.053-0.255
		c-0.005-0.059-0.026-0.113-0.05-0.163C6.05,11.598,7.248,8.325,9.486,5.766c2.645-3.024,6.468-4.758,10.49-4.758
		c4.017,0,7.84,1.738,10.49,4.769c2.22,2.538,3.429,5.777,3.445,9.11C33.887,14.94,33.87,15,33.865,15.063
		c-0.008,0.088,0.009,0.173,0.043,0.248c-0.013,0.503-0.053,1.007-0.12,1.511l-0.758,5.661c-0.205,1.526-0.607,2.936-1.076,3.772
		c-0.086,0.155-0.085,0.344,0.005,0.498C32.049,26.906,32.213,27,32.391,27h1.555C37.284,27,40,24.215,40,20.735
		C40,17.674,37.846,15.15,34.91,14.667z M9.738,22.047L8.98,16.415c-0.426-3.172,0.537-6.373,2.645-8.782
		c2.106-2.409,5.15-3.791,8.352-3.791s6.245,1.382,8.352,3.791c2.107,2.41,3.07,5.61,2.645,8.782l-0.758,5.633
		C29.527,27.151,25.126,31,19.977,31c-3.272,0-6.238-1.557-8.145-4H15c0.018,0,0.032-0.008,0.049-0.01
		C15.278,28.134,16.289,29,17.5,29h4c1.379,0,2.5-1.122,2.5-2.5S22.879,24,21.5,24h-4c-1.211,0-2.222,0.866-2.451,2.01
		C15.032,26.008,15.018,26,15,26h-3.853C10.429,24.819,9.932,23.486,9.738,22.047z M16,26.5c0-0.827,0.673-1.5,1.5-1.5h4
		c0.827,0,1.5,0.673,1.5,1.5S22.327,28,21.5,28h-4C16.673,28,16,27.327,16,26.5z M6.836,26H6.055c-2.804,0-5.091-2.285-5.134-5.111
		c0.01-0.041,0.016-0.083,0.016-0.125c0-2.472,1.75-4.516,4.145-4.996c0.022,0.387,0.041,0.774,0.093,1.162l0.758,5.631
		C6.096,23.78,6.404,24.93,6.836,26z M33.945,26h-0.767c0.37-0.917,0.673-2.12,0.842-3.384l0.758-5.661
		c0.058-0.425,0.097-0.851,0.117-1.275C37.271,16.145,39,18.228,39,20.792C39,23.664,36.732,26,33.945,26z"
        />
      </g>
    </svg>
  );
};

const NoteSvg = () => {
  return (
    <svg
  width={24}
      height={24}
  viewBox="0 0 16 16"
  xmlns="http://www.w3.org/2000/svg"
  version="1.1"
  fill="none"
  stroke="#000000"
  strokeLinecap="round"
  strokeLinejoin="round"
  strokeWidth="1.5"
>
  <polyline points="7.25 14.25,2.75 14.25,2.75 1.75,13.25 1.75,13.25 9.25" />
  <path d="m9.75 12.75 1.5 1.5 3-2.5m-8.5-4h4.5m-4.5 3h1.5m-1.5-6h4.5" />
</svg>

  );
};

const InternalSvg = () => {
  return (
    <svg
      fill="#9C9BA3"
      width={20}
      height={20}
      viewBox="0 0 512 512"
      enableBackground="new 0 0 512 512"
      id="Stay_x5F_organize"
      version="1.1"
      xmlSpace="preserve"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
    >
      <g>
        <path d="M488.303,229.44l-26.801-5.893c-5.053-1.107-8.932-5.08-10.004-10.143c-4.242-20.045-11.472-38.979-21.233-56.311   c-2.387-4.236-2.236-9.438,0.387-13.533l16.389-25.586c3.336-5.207,2.597-12.033-1.776-16.406l-27.195-27.197   c-4.373-4.373-11.197-5.111-16.404-1.777L378.79,87.241c-4.35,2.785-9.916,2.748-14.256-0.059   c-16.818-10.889-35.375-19.313-55.166-24.771c-4.697-1.295-8.289-5.084-9.332-9.844l-6.469-29.617   c-1.324-6.041-6.676-10.451-12.859-10.451h-38.465c-6.184,0-11.533,4.41-12.855,10.451l-5.863,26.786   c-1.1,5.027-5.037,8.958-10.063,10.051c-19.986,4.352-38.85,11.707-56.109,21.551c-4.248,2.42-9.479,2.301-13.598-0.336   L117.923,64.46c-5.207-3.332-12.035-2.592-16.406,1.779l-27.199,27.2c-4.373,4.371-5.111,11.2-1.777,16.407l15.131,23.629   c2.771,4.326,2.75,9.858-0.016,14.19c-10.576,16.566-18.775,34.793-24.119,54.205c-1.295,4.703-5.082,8.301-9.848,9.348   l-30.766,6.725c-6.041,1.326-10.422,6.676-10.422,12.859v38.463c0,6.184,4.381,11.533,10.422,12.859l28.128,6.156   c5.014,1.1,8.93,5.02,10.038,10.031c4.303,19.453,11.459,37.838,20.979,54.701c2.396,4.244,2.268,9.453-0.361,13.557l-17.297,27.02   c-3.336,5.205-2.595,12.031,1.778,16.404l27.199,27.199c4.373,4.371,11.198,5.111,16.405,1.775l24.54-15.713   c4.336-2.777,9.877-2.746,14.215,0.033c16.268,10.42,34.145,18.545,53.178,23.922c4.668,1.318,8.229,5.09,9.266,9.824l6.9,31.298   c1.324,6.039,6.674,10.168,12.857,10.168h38.465c6.184,0,11.531-4.129,12.857-10.168l6.189-28.145   c1.105-5.041,5.063-8.906,10.107-9.992c19.514-4.197,37.969-11.222,54.908-20.661c4.23-2.359,9.408-2.202,13.488,0.411   l26.771,17.148c5.207,3.336,12.033,2.597,16.404-1.774l27.201-27.199c4.369-4.371,5.109-11.198,1.777-16.405l-15.232-23.78   c-2.789-4.359-2.744-9.938,0.074-14.279c10.732-16.521,19.082-34.732,24.574-54.143c1.322-4.662,5.094-8.215,9.822-9.248   l30.147-6.645c6.041-1.324,10.197-6.674,10.197-12.857v-38.465C498.5,236.114,494.344,230.765,488.303,229.44z M254.407,407.585   c-82.277,0-148.979-66.701-148.979-148.979s66.701-148.979,148.979-148.979s148.977,66.701,148.977,148.979   S336.685,407.585,254.407,407.585z" />
        <path d="M196.716,237.659c12.982,0,23.504-10.525,23.504-23.504c0-12.982-10.521-23.506-23.504-23.506   c-12.98,0-23.504,10.523-23.504,23.506C173.212,227.134,183.735,237.659,196.716,237.659z" />
        <path d="M316.192,237.659c12.982,0,23.504-10.525,23.504-23.504c0-12.982-10.521-23.506-23.504-23.506   c-12.98,0-23.504,10.523-23.504,23.506C292.688,227.134,303.212,237.659,316.192,237.659z" />
        <circle cx="256.364" cy="229.3" r="23.506" />
        <path d="M255.5,262.124c-25.129,0-45,20.371-45,45.498v9.342c0,1.818,1.614,3.536,3.437,3.536h84.406   c1.818,0,2.157-1.718,2.157-3.536v-9.342C300.5,282.495,280.629,262.124,255.5,262.124z" />
        <path d="M226.599,258.633c-8.012-7.124-19.295-11.559-30.852-11.559c-25.133,0-46.247,20.288-46.247,45.397v9.336   c0,1.824,2.968,3.692,4.792,3.692h45.162C200.452,284.5,211.034,268.627,226.599,258.633z" />
        <path d="M315.993,246.978c-11.609,0-22.168,4.573-30.191,11.722c15.502,9.988,26.025,25.801,27.023,46.801h45.338   c1.822,0,3.337-1.868,3.337-3.692v-9.336c0-12.555-5.102-23.941-13.334-32.152C339.93,252.062,328.569,246.978,315.993,246.978z" />
      </g>
    </svg>
  );
};

const CompletedSvg = () => {
  return (
    <svg
      width={20}
      height={20}
      viewBox="0 0 1024 1024"
      fill="#9C9BA3"
      className="icon"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M824.8 1003.2H203.2c-12.8 0-25.6-2.4-37.6-7.2-11.2-4.8-21.6-12-30.4-20.8-8.8-8.8-16-19.2-20.8-30.4-4.8-12-7.2-24-7.2-37.6V260c0-12.8 2.4-25.6 7.2-37.6 4.8-11.2 12-21.6 20.8-30.4 8.8-8.8 19.2-16 30.4-20.8 12-4.8 24-7.2 37.6-7.2h94.4v48H203.2c-26.4 0-48 21.6-48 48v647.2c0 26.4 21.6 48 48 48h621.6c26.4 0 48-21.6 48-48V260c0-26.4-21.6-48-48-48H730.4v-48H824c12.8 0 25.6 2.4 37.6 7.2 11.2 4.8 21.6 12 30.4 20.8 8.8 8.8 16 19.2 20.8 30.4 4.8 12 7.2 24 7.2 37.6v647.2c0 12.8-2.4 25.6-7.2 37.6-4.8 11.2-12 21.6-20.8 30.4-8.8 8.8-19.2 16-30.4 20.8-11.2 4.8-24 7.2-36.8 7.2z"
        fill=""
      />
      <path
        d="M752.8 308H274.4V152.8c0-32.8 26.4-60 60-60h61.6c22.4-44 67.2-72.8 117.6-72.8 50.4 0 95.2 28.8 117.6 72.8h61.6c32.8 0 60 26.4 60 60v155.2m-430.4-48h382.4V152.8c0-6.4-5.6-12-12-12H598.4l-5.6-16c-12-33.6-43.2-56-79.2-56s-67.2 22.4-79.2 56l-5.6 16H334.4c-6.4 0-12 5.6-12 12v107.2zM432.8 792c-6.4 0-12-2.4-16.8-7.2L252.8 621.6c-4.8-4.8-7.2-10.4-7.2-16.8s2.4-12 7.2-16.8c4.8-4.8 10.4-7.2 16.8-7.2s12 2.4 16.8 7.2L418.4 720c4 4 8.8 5.6 13.6 5.6s10.4-1.6 13.6-5.6l295.2-295.2c4.8-4.8 10.4-7.2 16.8-7.2s12 2.4 16.8 7.2c9.6 9.6 9.6 24 0 33.6L449.6 784.8c-4.8 4-11.2 7.2-16.8 7.2z"
        fill=""
      />
    </svg>
  );
};

const CanceledSvg = () => {
  return (
    <svg
      fill="#9C9BA3"
      width={20}
      height={20}
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <defs>
        <style
          dangerouslySetInnerHTML={{
            __html:
              "\n      .cls-1 {\n        fill-rule: evenodd;\n      }\n    ",
          }}
        />
      </defs>
      <path
        id="cancel"
        className="cls-1"
        d="M936,120a12,12,0,1,1,12-12A12,12,0,0,1,936,120Zm0-22a10,10,0,1,0,10,10A10,10,0,0,0,936,98Zm4.706,14.706a0.951,0.951,0,0,1-1.345,0l-3.376-3.376-3.376,3.376a0.949,0.949,0,1,1-1.341-1.342l3.376-3.376-3.376-3.376a0.949,0.949,0,1,1,1.341-1.342l3.376,3.376,3.376-3.376a0.949,0.949,0,1,1,1.342,1.342l-3.376,3.376,3.376,3.376A0.95,0.95,0,0,1,940.706,112.706Z"
        transform="translate(-924 -96)"
      />
    </svg>
  );
};

const CurrentSvg = () => {
  return (
    <svg
      width={20}
      height={20}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M17 4.5H14V3.5C14 2.70435 13.6839 1.94129 13.1213 1.37868C12.5587 0.816071 11.7956 0.5 11 0.5H9C8.20435 0.5 7.44129 0.816071 6.87868 1.37868C6.31607 1.94129 6 2.70435 6 3.5V4.5H3C2.20435 4.5 1.44129 4.81607 0.87868 5.37868C0.316071 5.94129 0 6.70435 0 7.5V16.5C0 17.2956 0.316071 18.0587 0.87868 18.6213C1.44129 19.1839 2.20435 19.5 3 19.5H17C17.7956 19.5 18.5587 19.1839 19.1213 18.6213C19.6839 18.0587 20 17.2956 20 16.5V7.5C20 6.70435 19.6839 5.94129 19.1213 5.37868C18.5587 4.81607 17.7956 4.5 17 4.5ZM8 3.5C8 3.23478 8.10536 2.98043 8.29289 2.79289C8.48043 2.60536 8.73478 2.5 9 2.5H11C11.2652 2.5 11.5196 2.60536 11.7071 2.79289C11.8946 2.98043 12 3.23478 12 3.5V4.5H8V3.5ZM18 16.5C18 16.7652 17.8946 17.0196 17.7071 17.2071C17.5196 17.3946 17.2652 17.5 17 17.5H3C2.73478 17.5 2.48043 17.3946 2.29289 17.2071C2.10536 17.0196 2 16.7652 2 16.5V11C2.97544 11.3869 3.97818 11.7011 5 11.94V12.53C5 12.7952 5.10536 13.0496 5.29289 13.2371C5.48043 13.4246 5.73478 13.53 6 13.53C6.26522 13.53 6.51957 13.4246 6.70711 13.2371C6.89464 13.0496 7 12.7952 7 12.53V12.32C7.99435 12.4554 8.99649 12.5255 10 12.53C11.0035 12.5255 12.0057 12.4554 13 12.32V12.53C13 12.7952 13.1054 13.0496 13.2929 13.2371C13.4804 13.4246 13.7348 13.53 14 13.53C14.2652 13.53 14.5196 13.4246 14.7071 13.2371C14.8946 13.0496 15 12.7952 15 12.53V11.94C16.0218 11.7011 17.0246 11.3869 18 11V16.5ZM18 8.81C17.0274 9.22049 16.0244 9.55483 15 9.81V9.5C15 9.23478 14.8946 8.98043 14.7071 8.79289C14.5196 8.60536 14.2652 8.5 14 8.5C13.7348 8.5 13.4804 8.60536 13.2929 8.79289C13.1054 8.98043 13 9.23478 13 9.5V10.24C11.0113 10.54 8.98875 10.54 7 10.24V9.5C7 9.23478 6.89464 8.98043 6.70711 8.79289C6.51957 8.60536 6.26522 8.5 6 8.5C5.73478 8.5 5.48043 8.60536 5.29289 8.79289C5.10536 8.98043 5 9.23478 5 9.5V9.83C3.97562 9.57483 2.9726 9.24049 2 8.83V7.5C2 7.23478 2.10536 6.98043 2.29289 6.79289C2.48043 6.60536 2.73478 6.5 3 6.5H17C17.2652 6.5 17.5196 6.60536 17.7071 6.79289C17.8946 6.98043 18 7.23478 18 7.5V8.81Z"
        fill="#9C9BA3"
      />
    </svg>
  );
};

const HoldSvg = () => {
  return (
    <svg
      width={20}
      height={20}
      viewBox="0 0 14 14"
      xmlns="http://www.w3.org/2000/svg"
      fill="#9C9BA3"
    >
      <g fillRule="evenodd">
        <path d="M0 7a7 7 0 1 1 14 0A7 7 0 0 1 0 7z" />
        <path
          d="M13 7A6 6 0 1 0 1 7a6 6 0 0 0 12 0z"
          fill="#FFF"
          style={{ fill: "var(--svg-status-bg, #fff)" }}
        />
        <path d="M4.7 5.3c0-.2.1-.3.3-.3h.9c.2 0 .3.1.3.3v3.4c0 .2-.1.3-.3.3H5c-.2 0-.3-.1-.3-.3V5.3m3 0c0-.2.1-.3.3-.3h.9c.2 0 .3.1.3.3v3.4c0 .2-.1.3-.3.3H8c-.2 0-.3-.1-.3-.3V5.3" />
      </g>
    </svg>
  );
};

const ChevronDown = () => (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
      <path
        d="M6 9l6 6 6-6"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
const PdfSvg = () => (
<svg
  width={20}
  height={20}
  viewBox="0 0 20 20"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <path
    d="M16.6666 10.8333V8.88071C16.6666 8.19942 16.6666 7.85879 16.5398 7.55251C16.4128 7.24623 16.172 7.00537 15.6903 6.52365L11.7432 2.57653C11.3274 2.16079 11.1196 1.95292 10.862 1.82975C10.8084 1.80413 10.7536 1.78139 10.6976 1.76163C10.4283 1.66663 10.1344 1.66663 9.54642 1.66663C6.84227 1.66663 5.49018 1.66663 4.57436 2.40502C4.38934 2.55419 4.22082 2.72272 4.07164 2.90773C3.33325 3.82355 3.33325 5.17564 3.33325 7.87983V10.8333M10.8333 2.08329V2.49996C10.8333 4.85698 10.8333 6.03549 11.5655 6.76773C12.2978 7.49996 13.4763 7.49996 15.8333 7.49996H16.2499"
    stroke="#1F6BE6"
    strokeWidth="1.25"
    strokeLinecap="round"
    strokeLinejoin="round"
  />
  <path
    d="M16.4584 13.3334H14.3751C13.9148 13.3334 13.5417 13.7065 13.5417 14.1667V15.8334M13.5417 15.8334V18.3334M13.5417 15.8334H16.0417M3.54175 18.3334V16.25M3.54175 16.25V13.3334H5.00008C5.8055 13.3334 6.45841 13.9863 6.45841 14.7917C6.45841 15.5971 5.8055 16.25 5.00008 16.25H3.54175ZM8.54175 13.3334H9.79175C10.7122 13.3334 11.4584 14.0795 11.4584 15V16.6667C11.4584 17.5872 10.7122 18.3334 9.79175 18.3334H8.54175V13.3334Z"
    stroke="#1F6BE6"
    strokeWidth="1.25"
    strokeLinecap="round"
    strokeLinejoin="round"
  />
</svg>


  );
const PngSvg = () => (
<svg
  width={20}
  height={20}
  viewBox="0 0 20 20"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <path
    d="M12.5 6.66663H12.5083"
    stroke="#1F6BE6"
    strokeWidth="1.25"
    strokeLinecap="round"
    strokeLinejoin="round"
  />
  <path
    d="M10 2.5C16 2.5 17.5 4 17.5 10C17.5 16 16 17.5 10 17.5C4 17.5 2.5 16 2.5 10C2.5 4 4 2.5 10 2.5Z"
    stroke="#1F6BE6"
    strokeWidth="1.25"
    strokeLinecap="round"
    strokeLinejoin="round"
  />
  <path
    d="M2.9165 12.9166L6.6665 9.16665C7.43984 8.42248 8.39317 8.42248 9.1665 9.16665L13.3332 13.3333"
    stroke="#1F6BE6"
    strokeWidth="1.25"
    strokeLinecap="round"
    strokeLinejoin="round"
  />
  <path
    d="M11.6665 11.6667L12.4998 10.8334C13.2732 10.0892 14.2265 10.0892 14.9998 10.8334L17.0832 12.9167"
    stroke="#1F6BE6"
    strokeWidth="1.25"
    strokeLinecap="round"
    strokeLinejoin="round"
  />
</svg>



  );
const DocSvg = () => (
<svg
  width={20}
  height={20}
  viewBox="0 0 20 20"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <path
    d="M15.8333 2.5H4.16667C3.24619 2.5 2.5 3.24619 2.5 4.16667V15.8333C2.5 16.7538 3.24619 17.5 4.16667 17.5H15.8333C16.7538 17.5 17.5 16.7538 17.5 15.8333V4.16667C17.5 3.24619 16.7538 2.5 15.8333 2.5Z"
    stroke="#1F6BE6"
    strokeWidth="1.25"
    strokeLinecap="round"
    strokeLinejoin="round"
  />
  <path
    d="M5.8335 5.83337H14.1668"
    stroke="#1F6BE6"
    strokeWidth="1.25"
    strokeLinecap="round"
    strokeLinejoin="round"
  />
  <path
    d="M5.8335 10H14.1668"
    stroke="#1F6BE6"
    strokeWidth="1.25"
    strokeLinecap="round"
    strokeLinejoin="round"
  />
  <path
    d="M5.8335 14.1666H10.8335"
    stroke="#1F6BE6"
    strokeWidth="1.25"
    strokeLinecap="round"
    strokeLinejoin="round"
  />
</svg>



  );
const PptSvg = () => (
<svg
  width={20}
  height={20}
  viewBox="0 0 20 20"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <path opacity="0.2" d="M16.25 6.875H11.875V2.5L16.25 6.875Z" fill="#1F6BE6" />
  <path
    d="M17.5 11.875C17.5 12.0408 17.4342 12.1997 17.3169 12.3169C17.1997 12.4342 17.0408 12.5 16.875 12.5H15.9375V16.25C15.9375 16.4158 15.8717 16.5747 15.7544 16.6919C15.6372 16.8092 15.4783 16.875 15.3125 16.875C15.1467 16.875 14.9878 16.8092 14.8706 16.6919C14.7533 16.5747 14.6875 16.4158 14.6875 16.25V12.5H13.75C13.5842 12.5 13.4253 12.4342 13.3081 12.3169C13.1908 12.1997 13.125 12.0408 13.125 11.875C13.125 11.7092 13.1908 11.5503 13.3081 11.4331C13.4253 11.3158 13.5842 11.25 13.75 11.25H16.875C17.0408 11.25 17.1997 11.3158 17.3169 11.4331C17.4342 11.5503 17.5 11.7092 17.5 11.875ZM7.1875 13.4375C7.1875 14.0177 6.95703 14.5741 6.5468 14.9843C6.13656 15.3945 5.58016 15.625 5 15.625H4.375V16.25C4.375 16.4158 4.30915 16.5747 4.19194 16.6919C4.07473 16.8092 3.91576 16.875 3.75 16.875C3.58424 16.875 3.42527 16.8092 3.30806 16.6919C3.19085 16.5747 3.125 16.4158 3.125 16.25V11.875C3.125 11.7092 3.19085 11.5503 3.30806 11.4331C3.42527 11.3158 3.58424 11.25 3.75 11.25H5C5.58016 11.25 6.13656 11.4805 6.5468 11.8907C6.95703 12.3009 7.1875 12.8573 7.1875 13.4375ZM5.9375 13.4375C5.9375 13.1889 5.83873 12.9504 5.66291 12.7746C5.4871 12.5988 5.24864 12.5 5 12.5H4.375V14.375H5C5.24864 14.375 5.4871 14.2762 5.66291 14.1004C5.83873 13.9246 5.9375 13.6861 5.9375 13.4375ZM12.5 13.4375C12.5 14.0177 12.2695 14.5741 11.8593 14.9843C11.4491 15.3945 10.8927 15.625 10.3125 15.625H9.6875V16.25C9.6875 16.4158 9.62165 16.5747 9.50444 16.6919C9.38723 16.8092 9.22826 16.875 9.0625 16.875C8.89674 16.875 8.73777 16.8092 8.62056 16.6919C8.50335 16.5747 8.4375 16.4158 8.4375 16.25V11.875C8.4375 11.7092 8.50335 11.5503 8.62056 11.4331C8.73777 11.3158 8.89674 11.25 9.0625 11.25H10.3125C10.8927 11.25 11.4491 11.4805 11.8593 11.8907C12.2695 12.3009 12.5 12.8573 12.5 13.4375ZM11.25 13.4375C11.25 13.1889 11.1512 12.9504 10.9754 12.7746C10.7996 12.5988 10.5611 12.5 10.3125 12.5H9.6875V14.375H10.3125C10.5611 14.375 10.7996 14.2762 10.9754 14.1004C11.1512 13.9246 11.25 13.6861 11.25 13.4375ZM3.125 8.75V3.125C3.125 2.79348 3.2567 2.47554 3.49112 2.24112C3.72554 2.0067 4.04348 1.875 4.375 1.875H11.875C11.9571 1.87494 12.0384 1.89105 12.1143 1.92241C12.1902 1.95378 12.2591 1.99979 12.3172 2.05781L16.6922 6.43281C16.7502 6.4909 16.7962 6.55985 16.8276 6.63572C16.859 6.71159 16.8751 6.7929 16.875 6.875V8.75C16.875 8.91576 16.8092 9.07473 16.6919 9.19194C16.5747 9.30915 16.4158 9.375 16.25 9.375C16.0842 9.375 15.9253 9.30915 15.8081 9.19194C15.6908 9.07473 15.625 8.91576 15.625 8.75V7.5H11.875C11.7092 7.5 11.5503 7.43415 11.4331 7.31694C11.3158 7.19973 11.25 7.04076 11.25 6.875V3.125H4.375V8.75C4.375 8.91576 4.30915 9.07473 4.19194 9.19194C4.07473 9.30915 3.91576 9.375 3.75 9.375C3.58424 9.375 3.42527 9.30915 3.30806 9.19194C3.19085 9.07473 3.125 8.91576 3.125 8.75ZM12.5 6.25H14.7414L12.5 4.00859V6.25Z"
    fill="#1F6BE6"
  />
</svg>




  );

export {
  Eyeopen,
  Eyeclose,
  Dashboardsvg,
  Contractsvg,
  Manageapplication,
  Manageroletab,
  Vendororder,
  ReportReciptSvg,
  PrintSvg,
  ReportOrderReport,
  ReportTaxReport,
  NotificationSvg,
  SuportSvg,
  NoteSvg,
  InternalSvg,
  CompletedSvg,
  CanceledSvg,
  CurrentSvg,
  HoldSvg,
  StatsSvg,
  ChevronDown,
  AdminSettingsSvg,
  ReportsSvg,
  HourlySvg,
  FinecialSvg,
  LeaveManagement,PdfSvg,PngSvg,DocSvg,PptSvg,EmployeePlSvg,ProjectsSvg,BTTeamStatusSvg,CurrentTeamStatusSvg
};
